module.exports = __webpack_public_path__ + "img/n5-2.81e4e1b9.png";